import { Drawer } from 'antd';
import classNames from 'classnames';

import IconButton from '../buttons/IconButton';
import { useShipmentDetailDrawerStyles } from './ShipmentDetailDrawer.styles';

export default function ShipmentDetailDrawer({
  className,
  open,
  children,
  onClose,
  header,
  leftHeader,
  rightHeader,
}) {
  const { styles } = useShipmentDetailDrawerStyles();

  return (
    <Drawer
      rootClassName={classNames(styles.shipmentDetailDrawer, className)}
      closable
      title={header}
      closeIcon={
        <IconButton
          icon="times"
          className="CloseButton"
          data-subject="drawer"
          data-action="close"
        />
      }
      destroyOnHidden
      mask
      maskClosable
      open={open}
      onClose={onClose}
    >
      {leftHeader && <div className={styles.topLeftHeader}>{leftHeader}</div>}
      {rightHeader && (
        <div className={styles.topRightHeader}>{rightHeader}</div>
      )}
      {children}
    </Drawer>
  );
}
